export const calculateAverage = (numbers: Array<number>): number => {
	if (!numbers.length) {
		throw new Error('Cannot calculate the average of an empty list');
	}

	const sum = numbers.reduce((acc, curr) => acc + curr, 0);
	return sum / numbers.length;
};
